import Swiper from 'swiper';
import { Navigation, FreeMode, Keyboard, A11y } from 'swiper/modules';

const blocks = document.querySelectorAll(`.js-bf-block-image-slider`);

if (blocks.length > 0) {
    blocks.forEach((block) => {
        const slider = block.querySelector(`.bf-block-image-slider__slider .js-swiper`);
        const prev = block.querySelector(`.bf-block-image-slider__slider .swiper-button-prev`);
        const next = block.querySelector(`.bf-block-image-slider__slider .swiper-button-next`);
        const modal = block.querySelector('.modal');

        new Swiper(slider, {
            modules: [Navigation, FreeMode, Keyboard, A11y],
            a11y: true,
            rewind: true,
            freeMode: true,
            speed: 500,
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            keyboard: {
                enabled: true,
            },
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
            breakpoints: {
                600: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            },
        });

        if (modal) {
            const modalSlider = modal.querySelector(`.js-swiper`);
            const modalPrev = modal.querySelector(`.swiper-button-prev`);
            const modalNext = modal.querySelector(`.swiper-button-next`);
            const triggers = block.querySelectorAll('[data-micromodal-trigger]');
            console.log('test');
            const modalSwiper = new Swiper(modalSlider, {
                modules: [Navigation, FreeMode, Keyboard, A11y],
                autoHeight: true,
                a11y: true,
                rewind: true,
                speed: 500,
                grabCursor: true,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    prevEl: modalPrev,
                    nextEl: modalNext,
                },
            });

            triggers.forEach((trigger, index) => {
                trigger.addEventListener('click', () => {
                    modalSwiper.slideTo(index);
                });
            });
        }
    });
}
